import { ElNotification } from 'element-plus'
import { useGoatStore } from '@/stores/goat'

interface ConnectedGame {
  id: number
  nick?: string
  lvl?: number
  guild?: string
  avatar?: string
  loyaltyLeague?: string
  loyaltyLeagueLogo?: string
}

const connectedGames = ref<Record<Games.GameKeyType, ConnectedGame>>({})
const exclusiveOffers = ref<Record<Games.GameKeyType, Games.Offer>>({})
const visibilityConnectDialog = ref(false)
const connectionDialogGameKey = ref<Games.GameKeyLax>(null)
const isRequired = ref(false)
function openConnectionDialog(gameKey: Games.GameKeyLax, required = false) {
  connectionDialogGameKey.value = gameKey
  isRequired.value = required
  visibilityConnectDialog.value = true
}
const connectionCheckingLoading = ref<Record<Games.GameKeyType, boolean>>({})

function renderApiOffer(
  offer: Games.Offer,
  gameKey: Games.GameKeyType
): Games.Offer | null {
  const { games, numbersShortHuman } = siteUtils
  offer.gameKey = gameKey
  offer._loyaltyPoints = offer?.loyaltyPoints ? numbersShortHuman(offer?.loyaltyPoints || 0) : ''
  offer.extraValueInfo = offer.extraValueInfo || 'FREE'
  if (offer.extraValueInfo === 'free') {
    offer.extraValueInfo = 'FREE'
  }
  const imgStorageUrl = games?.[gameKey]?.imgStorageUrl ?? ''
  if (offer.items?.length) {
    for (const offerItem of offer.items) {
      offerItem._amountShort = offerItem.amount ? numbersShortHuman(offerItem.amount || 0) : ''
      offerItem._bonusAmountShort = offerItem.bonusAmount ? numbersShortHuman(offerItem.bonusAmount || 0) : ''
      if (imgStorageUrl.length) {
        if (offerItem.asset && offerItem.asset.slice(0, 4) !== 'http') {
          offerItem.asset = imgStorageUrl + offerItem.asset
        }
      }
    }
  }
  if (imgStorageUrl.length) {
    if (offer.asset && offer.asset.slice(0, 4) !== 'http') {
      offer.asset = imgStorageUrl + offer.asset
    }
  }
  return offer
}
async function checkConnection(gameKey: Games.GameKeyLax, open = false, optionsNotify = {} as Record<string, any>) {
  const goat = useGoatStore()
  const auth = useAuthStore()
  const { getGoatApiUrl, games } = siteUtils
  if (gameKey) {
    connectionCheckingLoading.value[gameKey] = true
  }
  const { getAxiosInstance, catchError } = appUtilsPlugin
  ElNotification.closeAll()
  let customClass = 'child-inherit-colors z-999999 right-1/2 translate-x-1/2 large'
  if (optionsNotify.appendTo) {
    customClass += ' absolute'
  }
  await getAxiosInstance()
    ?.get(getGoatApiUrl('logged/alive'))
    .then((response) => {
      connectedGames.value = response?.data?.connected ?? {}
      if (response?.data?.integrationOffers) {
        const integrationOffers: Games.Offer[] = response.data.integrationOffers
        const offersMapById: Record<string, Games.Offer> = {}
        Object.values(integrationOffers).forEach((offer: Games.Offer) => {
          if (offer.id) {
            offersMapById[offer.id] = offer
          }
        })
        Object.values(games).forEach((gameSettings) => {
          const offer = offersMapById[gameSettings.offerImgId]
          if (offer) {
            const renderedOffer = renderApiOffer(offer, gameSettings.gameKey)
            if (renderedOffer) {
              exclusiveOffers.value[gameSettings.gameKey] = renderedOffer
            }
          }
        })
      }

      goat.updateGoatDetails({
        avatar: response?.data?.avatar ?? '',
        password_set: response?.data?.password_set ?? 0
      })

      if (gameKey && open && !connectedGames.value?.[gameKey]?.id) {
        openConnectionDialog(gameKey)
      }
      if (response?.data?.com !== undefined && auth.getCom !== response?.data?.com) {
        auth.updateCom(response.data.com)
      }
    })
    .catch(catchError({ customClass, ...optionsNotify }))
    .then(() => {
      if (gameKey) {
        connectionCheckingLoading.value[gameKey] = false
      }
    })
}
export {
  checkConnection,
  connectedGames,
  connectionCheckingLoading,
  connectionDialogGameKey,
  exclusiveOffers,
  isRequired,
  openConnectionDialog,
  visibilityConnectDialog
}
